
import { Vue, Component, Prop } from 'vue-property-decorator';
import { MonitoramentoInterface } from '@/shared/models/monitoramento/monitoramento.interface';

require('./styles.css');

@Component({
  components: {},
})

export default class CardMonitoramento extends Vue {
  private show = false;

  @Prop({ type: Object })
  private monitoramento!: MonitoramentoInterface;

  private toggleShow() {
    this.show = !this.show;
  }
}
